import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from 'axios';
import { toast } from 'react-toastify';

export const price = (price, discount) => {
  return price - (price * discount / 100);
};

export const BalanceChart = () => {
  const currentUser = useSelector((state) => state.data);
  const [userbalance, setUserbalance] = useState(false);
  const [epayBalance, setEpayBalance] = useState(false);
  const [prabhuBalance, setPrabhuBalance] = useState(false);

  const getData1 = async (currentUser) => {
    try {
      if (currentUser.user_type == "admin") {
        const response = await axios.post('/v2/remittance/getBalance');
        const { status, data } = response.data;
        if (status) {
          setPrabhuBalance(data.Balance);
        }

        const response1 = await axios.post('/recharge/admin/balance/get');
        const { epay_balance, user_balance, active_user_balance } = response1.data;
        setUserbalance({ ...epay_balance, ...user_balance, ...active_user_balance });
        setEpayBalance(epay_balance);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  useEffect(() => {
    getData1(currentUser);
  }, [currentUser]);
  return (
    <>
      {
        currentUser && (
          <div class="row">
            <div class="col-md-6 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <p class="card-title text-md-center text-xl-left">Wallet Balance(INR)</p>
                  <div
                    class="d-flex flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                    <h3 class="mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{(currentUser?.inr_wallet_balance).toFixed(2)}</h3>
                    <i class="ti-calendar icon-md text-muted mb-0 mb-md-3 mb-xl-0"></i>
                  </div>
                  <p class="mb-0 mt-2 text-danger">0.12% <span class="text-black ms-1"><small>(30 days)</small></span>
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <p class="card-title text-md-center text-xl-left">Remitance Balance(INR)</p>
                  <div
                    class="d-flex flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                    <h3 class="mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{currentUser?.remit_balance}</h3>
                    <i class="ti-user icon-md text-muted mb-0 mb-md-3 mb-xl-0"></i>
                  </div>
                  <p class="mb-0 mt-2 text-danger">0.47% <span class="text-black ms-1"><small>(30 days)</small></span>
                  </p>
                </div>
              </div>
            </div>
            {
              userbalance && (
                <>
                  <div class="col-md-6 grid-margin stretch-card">
                    <div class="card">
                      <div class="card-body">
                        <p class="card-title text-md-center text-xl-left">Users Wallet Balance(INR)</p>
                        <div
                          class="d-flex flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                          <h3 class="mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{(userbalance?.wallet_balance).toFixed(2)}</h3>
                          <i class="ti-agenda icon-md text-muted mb-0 mb-md-3 mb-xl-0"></i>
                        </div>
                        <p class="mb-0 mt-2 text-success">64.00%<span class="text-black ms-1"><small>(30 days)</small></span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 grid-margin stretch-card">
                    <div class="card">
                      <div class="card-body">
                        <p class="card-title text-md-center text-xl-left">User Remitance Balance(INR)</p>
                        <div
                          class="d-flex flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                          <h3 class="mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{userbalance?.remittance_balance}</h3>
                          <i class="ti-layers-alt icon-md text-muted mb-0 mb-md-3 mb-xl-0"></i>
                        </div>
                        <p class="mb-0 mt-2 text-success">23.00%<span class="text-black ms-1"><small>(30 days)</small></span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 grid-margin stretch-card">
                    <div class="card">
                      <div class="card-body">
                        <p class="card-title text-md-center text-xl-left">Active Users Wallet Balance(INR)</p>
                        <div
                          class="d-flex flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                          <h3 class="mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{Number(userbalance?.active_wallet_balance || 0).toFixed(2)}</h3>
                          <i class="ti-agenda icon-md text-muted mb-0 mb-md-3 mb-xl-0"></i>
                        </div>
                        <p class="mb-0 mt-2 text-success">64.00%<span class="text-black ms-1"><small>(30 days)</small></span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 grid-margin stretch-card">
                    <div class="card">
                      <div class="card-body">
                        <p class="card-title text-md-center text-xl-left">Active User Remitance Balance(INR)</p>
                        <div
                          class="d-flex flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                          <h3 class="mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{userbalance?.active_remittance_balance}</h3>
                          <i class="ti-layers-alt icon-md text-muted mb-0 mb-md-3 mb-xl-0"></i>
                        </div>
                        <p class="mb-0 mt-2 text-success">23.00%<span class="text-black ms-1"><small>(30 days)</small></span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 grid-margin stretch-card">
                    <div class="card">
                      <div class="card-body">
                        <p class="card-title text-md-center text-xl-left">EPAY Balance</p>
                        <div
                          class="d-flex flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                          <h3 class="mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{epayBalance}</h3>
                          <i class="ti-layers-alt icon-md text-muted mb-0 mb-md-3 mb-xl-0"></i>
                        </div>
                        <p class="mb-0 mt-2 text-success">23.00%<span class="text-black ms-1"><small>(30 days)</small></span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 grid-margin stretch-card">
                    <div class="card">
                      <div class="card-body">
                        <p class="card-title text-md-center text-xl-left">Prabhu Balance</p>
                        <div
                          class="d-flex flex-wrap justify-content-between justify-content-md-center justify-content-xl-between align-items-center">
                          <h3 class="mb-0 mb-md-2 mb-xl-0 order-md-1 order-xl-0">{prabhuBalance}</h3>
                          <i class="ti-layers-alt icon-md text-muted mb-0 mb-md-3 mb-xl-0"></i>
                        </div>
                        <p class="mb-0 mt-2 text-success">23.00%<span class="text-black ms-1"><small>(30 days)</small></span>
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              )
            }
          </div>
        )
      }
    </>
  );
};

export const getNoticeImageUrl = (image) => {
  if (!image) return "";
  if (image.startsWith("data:")) return image;
  const backendUrl = process.env.REACT_APP_BACKEND_URL || "";
  if (image.includes("/uploads/")) {
    const uploadPath = image.substring(image.indexOf("/uploads/"));
    return `${backendUrl.replace(/\/$/, "")}${uploadPath}`;
  }
  if (image.startsWith("http://") || image.startsWith("https://")) {
    return image;
  }
  return `${backendUrl.replace(/\/$/, "")}/${image.replace(/^\//, "")}`;
};